import React from 'react';
import './AmbientBackdrop.css';

/**
 * Full-bleed atmosphere behind every page. Reads the --mood-* tokens set by
 * MoodProvider, so switching routines re-colors the entire screen.
 */
const AmbientBackdrop: React.FC = () => (
  <div className="ambient-backdrop" aria-hidden="true">
    <span className="ambient-tint" />
    <span className="ambient-glow ambient-glow--1" />
    <span className="ambient-glow ambient-glow--2" />
    <span className="ambient-glow ambient-glow--3" />
    <span className="ambient-vignette" />
  </div>
);

export default AmbientBackdrop;
